import {
  Backdrop, Card, CardContent, CardHeader, Divider,
  Input, 
  Paper,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
  TableRow,
  Checkbox,
  Tooltip,
  Button,
  Snackbar,
  Popover,
  Typography,
  Box,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  DialogActions,
  DialogContentText
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import ControlCameraIcon from '@material-ui/icons/ControlCamera';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'src/utils/axios';
import { getUser, sc } from 'src/utils/Common';
import { setMalzemeIhtiyacAdet } from 'src/utils/storage/NavBarAdet';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import { groupBy } from 'lodash';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import Alert from 'src/components/Alert';
import moment from 'moment';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import TriageMaterialOrder from 'src/views/MaterialOrder/Create/TriageMaterialOrder'
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import CancelIcon from '@material-ui/icons/Cancel';

const useStyles = makeStyles((theme) => ({
  root: {},
  contentMI: {
    margin: 2
  },
  backdropMI: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  searchMI: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconMI: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInputMI: {
    flexGrow: 1
  },
  disabledButton: {
    color: 'grey !important', 
    borderColor: 'grey !important' 
  },
  activeButton: {
    color: '#7ABA78', 
    borderColor: '#7ABA78' 
  },
  moreButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: '100%',
  },
  moreButton: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1, 2),
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.background.paper,
    },
  },
  icon: {
    marginLeft: theme.spacing(1),
  },
}));
function MaterialStatusManaging({ className,title, ...rest  }) {
  const classes = useStyles();
  const { t } = useTranslation('material_requirement');
  const [Loading, setLoading] = useState(true);
  const [orderData, setOrderData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const SessionUser = getUser();
  const [stateDurum, setStateDurum] = useState('');
  const [delivered, setDelivered] = useState([]);
  const [faulty, setFaulty] = useState([]);
  const [missing, setMissing] = useState([]);
  const [deliveryStatus, setDeliveryStatus] = useState([]);
  var groupedOrders = groupBy(filteredData, 'MaterialOrderId');
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [ResponseDsc, setResponseDsc] = useState('');
  const [ResponseType, setResponseType] = useState('success');
  const [materialDeliverStatusData,setMaterialDeliverStatusData] = useState([]);
  const TeknisyenKodu = SessionUser.TechnicianId;
  const [selectedOrderId,setSelectedOrderId] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [ErpStatusOpen, setErpStatusOpen] = React.useState(false);
  const [ErpStatusData, setErpStatusData] = React.useState([]);
  const [OpenTriageMaterialOrder, setOpenTriageMaterialOrder] = useState(false);
  const [OrderNr, setOrderNr] = useState('');
  const [open1, setOpen1] = React.useState(false);
  const [Uyari1, setUyari1] = React.useState('');
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [notDeliveredMaterials,setNotDeliveredMaterials]=useState();
  const [workOrderId, setWorkOrderId] = useState(null);
  const [disabledButton,setDisabledButton] = useState(false);
  const [materialUpdates, setMaterialUpdates] = useState([]);
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message')
  });

  const [visibleItems, setVisibleItems] = useState(5);
  const loadMore = () => {
    setVisibleItems(prevVisibleItems => prevVisibleItems + 5);
  };
  
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const locale = localStorage.getItem('i18nextLng');

  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: 'rgb(60, 179, 113)',
      color: theme.palette.common.white,
    },
    body: {
      fontSize: 14,
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
      },
    },
  }))(TableRow);

  const getSpareUserColor = s => {
    if (s.Quantity !== "0,0") {
      return (
        <Avatar
          size="small"
          style={{ color: 'white', backgroundColor: 'green' }}
        >
          <AccountCircleIcon />
        </Avatar>
      );
    } else {
      return (
        <Avatar
          size="small"

          style={{ color: '#424242', backgroundColor: 'red' }}
        >
          <AccountCircleIcon />
        </Avatar>
      );
    }
  };

  const GetMaterialOrdersForTechnician = () =>
  {
      setLoading(true);
      let mounted = true;
      var WorkOrderId = 0;
      var MaterialOrderId = 0;
      const fetchTodos = () => {
      axios.get(`/GetMaterialOrdersForTechnician/${WorkOrderId}/${MaterialOrderId}/${SessionUser.ServiceShopId}/${TeknisyenKodu}`).then((response) => {
        if (mounted) {
        const Deger = response.data;
        if (Deger.length === 0) {
        setOrderData([]);
        } else {
        setOrderData(Deger);

        var comboBoxList = Deger.flatMap((material, materialIndex) => (
          Array.from({ length: material.Quantity }).map((_, quantityIndex) => ({
          Id: `${material.MaterialOrderId}-${material.MaterialId}-${quantityIndex}`,
          ComboBoxValue: false,
          OrderId: material.MaterialOrderId,
          MaterialId: material.MaterialId,
          GeneralDeliveryStatusId: 4
          }))
        ));
        setDelivered(comboBoxList);
        setFaulty(comboBoxList);
        setMissing(comboBoxList);
        GetMaterialDeliveryStatus(comboBoxList);
        }
        let Adet = Deger.length;
        setMalzemeIhtiyacAdet(Adet);
        setLoading(false);
        }
        }).catch((error) => {
        setMalzemeIhtiyacAdet(0);
        setLoading(false);
        });
      };
        fetchTodos();
        return () => {
        mounted = false;
      };
  }

  useEffect(() => {
    GetMaterialOrdersForTechnician();
  }, [locale]);

  const handleChange = (uniqueMaterialId, value, orderId) => {
    const updateStatus = (statusArray, statusValue) => {
      return statusArray.map(item => {
        if (item.Id === uniqueMaterialId) {
          return { ...item, ComboBoxValue: statusValue };
        }
        return item;
      });
    };
  
    setDelivered(prevState => updateStatus(prevState, value === 'delivered'));
    setFaulty(prevState => updateStatus(prevState, value === 'faulty'));
    setMissing(prevState => updateStatus(prevState, value === 'missing'));
  
    setMaterialUpdates(prevUpdates => {
      const existingUpdate = prevUpdates.find(update => update.UniqueMaterialId === uniqueMaterialId);
      const newUpdate = { UniqueMaterialId: uniqueMaterialId, DeliveryStatusId: value, OrderId: orderId };
  
      if (existingUpdate) {
        return prevUpdates.map(update =>
          update.UniqueMaterialId === uniqueMaterialId ? newUpdate : update
        );
      } else {
        return [...prevUpdates, newUpdate];
      }
    });
  };

  const updateDeliveryStatus = (orderId) => {
    setWorkOrderId(groupedOrders[orderId][0].WorkOrderId);

    if (delivered && delivered.length > 0) {
        let notdeliveredmaterials = delivered
        .filter(item => item.OrderId === orderId && item.ComboBoxValue === false)
        .map(item => item.MaterialId);

        setNotDeliveredMaterials(notdeliveredmaterials);

        let areAllDeliveredTrue = delivered.filter(item => item.OrderId === orderId && item.ComboBoxValue === true).length;
        let control = delivered.filter(item => item.OrderId === orderId).length;

        if (areAllDeliveredTrue === control) {
          SetMaterialOrderDeliveryStatus(orderId,1);
        }else{
          SetMaterialOrderDeliveryStatus(orderId,5);
          setOpenTriageMaterialOrder(true);
        }
    } else {
      SetMaterialOrderDeliveryStatus(orderId,5);
      setOpenTriageMaterialOrder(true);
    }
  }

  useEffect(() => {
    const filteredData = stateDurum === ''
      ? [...orderData]
      : orderData.filter((item) =>
          sc(item.MaterialOrderId, stateDurum) || sc(item.WorkOrderId, stateDurum) 
          || sc(item.MaterialCode, stateDurum) || sc(item.MaterialDesc, stateDurum)  
        );
  
    setFilteredData(filteredData);
  }, [stateDurum, orderData]);

  const SetMaterialDeliveryStatus = (orderId,uniqueMaterialId,deliveryStatusId) => {
    const requestDto = {
      OrderId: orderId,
      UniqueMaterialId: uniqueMaterialId,
      DeliveryStatusId: deliveryStatusId
    }

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };

    axios
        .post('/SetMaterialDeliveryStatus/', requestDto, config)
        .then(response => {
            var ResponseData = response.data[0];
            if (ResponseData.ErrorCode != 10) {
              setResponseType('error');
              setResponseDsc(response.data.ErrorMessage);
              setOpenSnackbar(true);
            }
        })
        .catch(error => {
          setResponseType('error');
          setResponseDsc(error);
          setOpenSnackbar(true); 
        });
  }
  
  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
  
    setOpenSnackbar(false);
  };

  const handleConfirmButtonIsDisabled = (orderId) => {
    // Calculate the total material count, taking Quantity into account
    var generalMaterialCount = groupedOrders[orderId].reduce((acc, material) => {
      return acc + (material.Quantity > 1 ? material.Quantity : 1);
    }, 0);
  
    var selectedMaterialCount = (materialUpdates && materialUpdates.length > 0) ? materialUpdates.filter(x => x.OrderId == orderId).length : materialDeliverStatusData.filter(x => x.OrderId == orderId).length;
  
    if(generalMaterialCount === selectedMaterialCount) {
      setDisabledButton(false);
    } else {
      setDisabledButton(true);
    }
  };

  const GetMaterialDeliveryStatus = (list) => {
    axios
      .get('/GetMaterialDeliveryStatus/' + SessionUser.TechnicianId  + '/' + SessionUser.ServiceShopId)
      .then(response => {
        const res = response.data.length === 0 ? [] : response.data;
        setMaterialDeliverStatusData(res);
        setLoading(false);

        const data = list.map(item => {
          const matchedStatus = res.find(statusItem => statusItem.OrderId === item.OrderId);
          return {
            ...item,
            GeneralDeliveryStatusId: matchedStatus ? matchedStatus.GeneralDeliveryStatusId : 4
          };
        });
        setDeliveryStatus(data);

        const updatedDelivered = data.map(item => ({
          ...item,
          ComboBoxValue: res.some(statusItem => statusItem.UniqueMaterialId === item.Id && statusItem.DeliveryStatusId === 1)
        }));
        const updatedFaulty = data.map(item => ({
          ...item,
          ComboBoxValue: res.some(statusItem => statusItem.UniqueMaterialId === item.Id && statusItem.DeliveryStatusId === 2)
        }));
        const updatedMissing = data.map(item => ({
          ...item,
          ComboBoxValue: res.some(statusItem => statusItem.UniqueMaterialId === item.Id && statusItem.DeliveryStatusId === 3)
        }));

        setDelivered(updatedDelivered);
        setFaulty(updatedFaulty);
        setMissing(updatedMissing);
      })
      .catch(error => {
        setLoading(false);
      });
  }

  const SetMaterialOrderDeliveryStatus = (orderId,deliveryStatusId) => {
    axios
        .post('/SetMaterialOrderDeliveryStatus/' + orderId + '/' + deliveryStatusId)
        .then(response => {
            var ResponseData = response.data[0];
            
            if (ResponseData.ErrorCode != 10) {
              setResponseType('error');
              setResponseDsc(response.data.ErrorMessage);
              setOpenSnackbar(true);
            }
            GetMaterialOrdersForTechnician();
        })
        .catch(error => {
          setResponseType('error');
          setResponseDsc(error);
          setOpenSnackbar(true); 
        });
  }


  const handleConfirm = () => {
    updateDeliveryStatus(selectedOrderId);
    handleClose();
  };

  const handleClickOpen = (event, orderId) => {
    setAnchorEl(event.currentTarget);
    setSelectedOrderId(orderId);
    handleConfirmButtonIsDisabled(orderId);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const ErpStatusPopup = (ErpNr) => {
    axios
      .get('/GetErpWarehouseMaterialStatus/' + ErpNr + '/' + localStorage.getItem('i18nextLng'))
      .then(response => {
        const res = response.data.length === 0 ? [] : response.data;
        setErpStatusData(res);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
    setErpStatusOpen(true);
  }
  
  const getOrderNr = (orderNr) => {
    if (orderNr !== undefined) {
      setOrderNr(orderNr);
    }
  };

  function GetMaterialOrderSAPCountry() {
    axios
      .post('/GetMaterialOrderSAPCountry/' + SessionUser.TenantId)
      .then(response => {
        if (response.data) {
          if (OrderNr !== '' && OrderNr !== undefined) {
            CreateOrderInSap(OrderNr);
          } else {
            CreateOrderInSap(selectedOrderId);
          }
        }
      });
  }

  function CreateOrderInSap(MaterialOrderId) {
    axios
      .post('/CreateOrderInSAP/' + MaterialOrderId)
      .then(response => {
        if (response.data[0]?.ErrorCode == 1000) {
          setresponseMessage({
            ErrorCode: response.data[0]?.ErrorCode,
            ErrorDescription: response.data[0]?.ErrorDescription
          });
          setUyariTip('error');
          setUyari(true);
          setOpen1(true);
          setUyari1(responseMessage.ErrorDescription);
          return;
        } else {
          setresponseMessage({
            ErrorCode: 0,
            ErrorDescription: t('sendSapSuccess')
          });
          setUyariTip('success');
          setUyari(true);
          setOpen1(true);
          setUyari1(responseMessage.ErrorDescription);
        }
      });
  }

  const handleCloseTriageMaterialOrder = () => {
    if (OrderNr === '' || OrderNr === undefined) {
      setOpen1(true);
      setUyari1(t('lblObligationOrderMsg'));
    } else {
      setOpenTriageMaterialOrder(false);
      GetMaterialOrderSAPCountry();
    }
  };

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  useEffect(() => {
    if (anchorEl) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [anchorEl]);
 
  return (
    <div>
      {window.navigator.onLine
        && (
          <div className={clsx(classes.root, className)}>
            <Snackbar
              open={openSnackbar}
              autoHideDuration={3000}
              onClose={handleSnackbarClose}
            >
              <Alert
                onClose={handleSnackbarClose}
                message={ResponseDsc}
                variant={ResponseType}
              />
            </Snackbar>
            <Card>
              <CardHeader title={title} />
              <Divider />
              {
                uyari
                  ? <Alert onClose={uyariKapat} open={uyari} message={uyariAciklama || ''} variant={uyariTip} />
                  : <div />
              }
              <Paper
                className={classes.searchMI}
                elevation={1}
              >
                <SearchIcon className={classes.searchIconMI} />
                <Input
                  className={classes.searchInputMI}
                  disableUnderline
                  // value={stateDurum}
                  onChange={(e) => setStateDurum(e.target.value)}
                  placeholder={t('Arama_Yap')}
                />
              </Paper>
              {
                Loading
                  ? (
                    <Backdrop className={classes.backdropMI} open={Loading}>
                      <CircularProgress color="inherit" />
                    </Backdrop>
                  )
                  : <div />
              }
              {groupedOrders?.length !== 0 ?
              <CardContent className={classes.contentMI}>
                <Grid container item xs={12} sm={12} lg={12} spacing={2}>
                <Grid item xs={12} sm={12} lg={12}>
                  {Object.keys(groupedOrders).slice(0, visibleItems).map(orderId => (
                    <Card key={orderId} style={{marginBottom:'5px'}}>
                      <CardContent className={classes.cardscontent}>
                        <Grid container spacing={1}>
                          <Grid item xs={6} sm={2} lg={2}>
                            <TextField
                              size="small"
                              id={`orderNumber-${orderId}`}
                              disabled
                              autoComplete="no"
                              value={groupedOrders[orderId][0].MaterialOrderId} 
                              fullWidth
                              label={t('lblOrderNumber')}
                              variant="outlined"
                            />
                          </Grid>
                          <Grid item xs={6} sm={2} lg={2}>
                            <TextField
                              size="small"
                              id={`workorderNumber-${orderId}`}
                              disabled
                              autoComplete="no"
                              value={groupedOrders[orderId][0].WorkOrderId} 
                              fullWidth
                              label={t('lblWorkOrderNumber')}
                              variant="outlined"
                            />
                          </Grid>
                          <Grid item xs={12} sm={4} lg={4}>
                            <TextField
                              size="small"
                              id={`workOrderStatus-${orderId}`}
                              disabled
                              autoComplete="no"
                              value={groupedOrders[orderId][0].WorkOrderStatus} 
                              fullWidth
                              label={t('lblWorkOrderStatus')}
                              variant="outlined"
                            />
                          </Grid>
                          <Grid item xs={6} sm={2} lg={2}>
                            <TextField
                              size="small"
                              id={`consumer-${orderId}`}
                              autoComplete="no"
                              value={new Date(groupedOrders[orderId][0].OrderDate).toLocaleDateString()} 
                              fullWidth
                              label={t('lblOrderDate')}
                              variant="outlined"
                              disabled
                            /> 
                          </Grid>
                          <Grid item xs={6} sm={2} lg={2}>
                            <TextField
                              size="small"
                              id={`shipTo-${orderId}`}
                              autoComplete="no"
                              value={groupedOrders[orderId][0].ShipTo} 
                              fullWidth
                              label={t('lblShipTo')}
                              variant="outlined"
                              disabled
                            /> 
                          </Grid>
                          <Grid item xs={11} sm={2} lg={2}>
                              <TextField
                                size="small"
                                id="sapNumber"
                                disabled
                                autoComplete="no"
                                value={groupedOrders[orderId][0].SapNumber}
                                fullWidth
                                label={t('lblSapNumber')}
                                variant="outlined"
                              />
                            </Grid>
                            <Grid item xs={1} sm={1} lg={1}>
                            {groupedOrders[orderId][0].SapNumber !== "" ? 
                              <FormControlLabel
                                control={
                                  <Box p={0.8}>
                                    <ControlCameraIcon
                                      size="small"
                                      color="primary"
                                      style={{ color: '#3399FF' }}
                                      onClick={() => ErpStatusPopup(groupedOrders[orderId][0].SapNumber)}
                                    />
                                  </Box>
                                }
                              /> : 
                              <FormControlLabel
                              disabled
                              control={
                                <Box p={0.8}>
                                  <ControlCameraIcon
                                    size="small"
                                    color="primary"
                                    style={{ color: '#93b9c7' }}                               
                                  />
                                </Box>
                              } 
                            />}
                          </Grid>
                          <Grid item sm={1} lg={1}/>
                          <Grid item xs={12} sm={4} lg={4}>
                            <TextField
                              size="small"
                              id={`status-${orderId}`}
                              disabled
                              autoComplete="no"
                              value={
                                deliveryStatus.some(
                                  x => x.OrderId === groupedOrders[orderId][0].MaterialOrderId && x.GeneralDeliveryStatusId === 1
                                ) 
                                  ? t('lblDelivered') 
                                  : t('lblWaiting')
                              }
                              fullWidth
                              label={t('lblDeliveryStatus')}
                              variant="outlined"
                              inputProps={{
                                style: { backgroundColor: '#FCFFE0' } 
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={4} lg={4}>
                            <TextField
                              size="small"
                              id={`orderDsc-${orderId}`}
                              disabled
                              autoComplete="no"
                              value={groupedOrders[orderId][0].OrderDsc} 
                              fullWidth
                              label={t('lblOrderDsc')}
                              variant="outlined"
                            />
                          </Grid>
                        </Grid>
                        <Grid item xs={12} sm={12} lg={12}>
                          <TableContainer component={Paper} style={{ marginTop: '20px' }}>
                            <Table  aria-label="sticky table"  size="small">
                              <TableHead style={{backgroundColor:'#E1F0DA'}}>
                                <TableRow>
                                  <TableCell align="left" style={{ minWidth: 150 }}>{t('lblMaterialCode')}</TableCell>
                                  <TableCell align="left" style={{ minWidth: 200 }}>{t('lblMaterialDsc')}</TableCell>
                                  <TableCell align="center" style={{ minWidth: 100 }}>
                                    <div style={{ textAlign: 'center' }}>
                                      <LocalShippingIcon style={{ color: '#4F6F52' }}/>
                                      <div style={{ fontSize: '12px', color: '#4F6F52' }}>{t('lblDelivered')}</div>
                                    </div>
                                  </TableCell>
                                  <TableCell align="center" style={{ minWidth: 100 }}>
                                    <div style={{ textAlign: 'center' }}>
                                      <CancelIcon style={{ color: '#C40C0C' }}/>
                                      <div style={{ fontSize: '12px', color: '#C40C0C' }}>{t('lblFaulty')}</div>
                                    </div>
                                  </TableCell>
                                  <TableCell align="center" style={{ minWidth: 100 }}>
                                    <div style={{ textAlign: 'center' }}>
                                      <ErrorIcon style={{ color: '#EEC759' }}/>
                                      <div style={{ fontSize: '12px', color: '#EEC759' }}>{t('lblMissing')}</div>
                                    </div>
                                  </TableCell>
                                  <TableCell align="center" style={{ minWidth: 100 }}>
                                    <Button
                                      onClick={(event) => handleClickOpen(event, groupedOrders[orderId][0].MaterialOrderId)}
                                    >
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                      <ThumbUpIcon style={{color:'#7ABA78'}}/>
                                      <Typography style={{color:'#7ABA78'}}>
                                        {t('lblConfirm')}
                                      </Typography>
                                    </div>
                                    </Button>
                                    <Popover
                                      id={id}
                                      open={open}
                                      anchorEl={anchorEl}
                                      onClose={handleClose}
                                      anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center',
                                      }}
                                      transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center',
                                      }}
                                    >
                                      <Typography style={{padding:'4px'}}>
                                        {t('ApproveQuestion')}
                                      </Typography>
                                      <Button 
                                        variant="outlined" 
                                        style={{borderColor:'red',margin:'5px'}} 
                                        onClick={handleClose}>{t('lblCancel')}
                                      </Button>
                                      <Button 
                                        variant="outlined" 
                                        style={{borderColor:'red',margin:'5px'}} 
                                        disabled={disabledButton}  
                                        onClick={() => handleConfirm()}>{t('lblConfirm')}
                                      </Button>
                                    </Popover>
                                  </TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                              {groupedOrders[orderId].flatMap((data, materialIndex) => (
                                Array.from({ length: data.Quantity }).map((_, quantityIndex) => {
                                //Create a unique Id for every material.  
                                const materialUniqueId = `${orderId}-${data.MaterialId}-${quantityIndex}`;
                                return (
                                <TableRow key={materialUniqueId}>
                                  <TableCell align="left" style={{ minWidth: 150 }}>{data.MaterialCode}</TableCell>
                                  <TableCell align="left" style={{ minWidth: 200 }}>{data.MaterialDesc}</TableCell>
                                  <TableCell align="center" style={{ minWidth: 100 }}>
                                    <Checkbox
                                      id='1'
                                      checked={delivered.find(item => item.Id === materialUniqueId)?.ComboBoxValue || false}
                                      onChange={() => {
                                        handleChange(materialUniqueId, 'delivered',orderId);
                                        SetMaterialDeliveryStatus(data.MaterialOrderId,materialUniqueId,1);
                                      }}
                                    />
                                    </TableCell>
                                  <TableCell align="center" style={{ minWidth: 100 }}>
                                    <Checkbox
                                      id='2'
                                      checked={faulty.find(item => item.Id === materialUniqueId)?.ComboBoxValue || false}
                                      onChange={() => {
                                        handleChange(materialUniqueId, 'faulty',orderId);
                                        SetMaterialDeliveryStatus(data.MaterialOrderId,materialUniqueId,2);
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell align="center" style={{ minWidth: 100 }}>
                                    <Checkbox
                                      id='3'
                                      checked={missing.find(item => item.Id === materialUniqueId)?.ComboBoxValue || false}
                                      onChange={() => {
                                        handleChange(materialUniqueId, 'missing',orderId)
                                        SetMaterialDeliveryStatus(data.MaterialOrderId,materialUniqueId,3);
                                      }}
                                    />
                                  </TableCell>
                                </TableRow>
                                );
                                })
                                ))}
                            </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>
                      </CardContent>
                    </Card>
                  ))}
                </Grid>
                  {visibleItems < Object.keys(groupedOrders).length && (
                    <div className={classes.moreButtonContainer}>
                      <Button className={classes.moreButton} onClick={loadMore}>
                        {t('lblMore')}
                        <ArrowDropDownIcon className={classes.icon} />
                      </Button>
                    </div>
                  )}
                </Grid>
              </CardContent> : t('lblPartsDeliveryMsg')}
            </Card>
            <Dialog
                  open={ErpStatusOpen}
                  onClose={() => setErpStatusOpen(false)}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                  fullWidth
                  maxWidth='lg'
                >
                  <DialogTitle id="alert-dialog-title">
            <Typography  className={classes.typoHead}  variant="h3">{t('lblSparePartorderDetails')}</Typography>
              <Divider />
            </DialogTitle>
            <DialogContent>
              <List>
                <Grid>
                {Loading ? (
                  <CircularProgress
                    status="loading"
                    style={{ marginLeft: '50%' }}
                  />
                  
                ) : 
                  (
                    ErpStatusData?.out?.map(s => {
                      return (
                        <Grid>
                          <ListItem
                            fullWidth
                            alignItems="flex-start"
                            key={s.ORDER_NO}
                          >
                            <ListItemText
                              secondary={
                                <React.Fragment>
                                  <ListItem fullWidth alignItems="flex-start">
                                    <ListItemText
                                      secondary={
                                        <React.Fragment>
                                          <TableContainer component={Paper}>
                                            <Table className={classes.table} aria-label="customized table">
                                              <TableHead>
                                                <TableRow>
                                                  <StyledTableCell align="center">{t('lblOrderNo')}</StyledTableCell>
                                                  <StyledTableCell align="center">{t('lblOrderItem')}</StyledTableCell>
                                                  <StyledTableCell align="center">{t('lblOrderStatus')}</StyledTableCell>
                                                  <StyledTableCell align="center">{t('lblOrderDesc')}</StyledTableCell>
                                                  <StyledTableCell align="left">{t('lblOrderDate')}</StyledTableCell>
                                                  <StyledTableCell align="left">{t('lblDeliveryNo')}</StyledTableCell>
                                                  <StyledTableCell align="left">{t('lblDeliveryStatus')}</StyledTableCell>
                                                  <StyledTableCell align="left">{t('lblDeliveryDate')}</StyledTableCell>
                                                  <StyledTableCell align="left">{t('lblInvoiceNo')}</StyledTableCell>
                                                  <StyledTableCell align="left">{t('lblInvoiceDate')}</StyledTableCell>
                                                  <StyledTableCell align="left">{t('lblGoodIssueDate')}</StyledTableCell>
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                <StyledTableRow>
                                                  <StyledTableCell align='left'>{s.ORDER_NO}</StyledTableCell>
                                                  <StyledTableCell align="center">{s.ORDER_ITEM}</StyledTableCell>
                                                  <StyledTableCell align="right">{s.ORDER_STATUS}</StyledTableCell>
                                                  <StyledTableCell align="center">{s.ORDER_DESC}</StyledTableCell>
                                                  <TableCell align="left">{s.ORDER_DATE === "0000-00-00" ? '' : SessionUser.TenantId == 79 ? moment(s.ORDER_DATE).format('MM/DD/YYYY HH:mm') : moment(s.ORDER_DATE).format('DD/MM/YYYY HH:mm')}</TableCell>
                                                  <StyledTableCell align="left">{s.DELIVERY_NO}</StyledTableCell>
                                                  <StyledTableCell align="left">{s.DELIVERY_STATUS}</StyledTableCell>
                                                  <TableCell align="left">{s.DELIVERY_DATE === "0000-00-00" ? '' : SessionUser.TenantId == 79 ? moment(s.DELIVERY_DATE).format('MM/DD/YYYY HH:mm') : moment(s.DELIVERY_DATE).format('DD/MM/YYYY HH:mm')}</TableCell>
                                                  <StyledTableCell align="left">{s.INVOICE_NO}</StyledTableCell>
                                                  <TableCell align="left">{s.INVOICE_DATE === "0000-00-00" ? '' : SessionUser.TenantId == 79 ? moment(s.INVOICE_DATE).format('MM/DD/YYYY HH:mm') : moment(s.INVOICE_DATE).format('DD/MM/YYYY HH:mm')}</TableCell>
                                                  <TableCell align="left">{s.GOOD_ISSUE_DATE === "0000-00-00" ? '' : SessionUser.TenantId == 79 ? moment(s.GOOD_ISSUE_DATE).format('MM/DD/YYYY HH:mm') : moment(s.GOOD_ISSUE_DATE).format('DD/MM/YYYY HH:mm')}</TableCell>
                                                </StyledTableRow>
                                              </TableBody>
                                            </Table>
                                          </TableContainer>
                                        </React.Fragment>
                                      }
                                    />
                                  </ListItem>
                                  <Divider variant="inset" component="li" />
                                  <Divider variant="inset" component="li" />
                                </React.Fragment>
                              }
                            />
                          </ListItem>
                          <Divider variant="inset" component="li" />
                          <Divider variant="inset" component="li" />
                        </Grid>
                        
                      );
                    })
                  )}
                </Grid>
              </List>
              
              <Grid container item xs={12} sm={12} lg={12} row spacing={1} >
                {Loading ? (
                  <CircularProgress
                    status="loading"
                    style={{ marginLeft: '50%' }}
                  />
                ) : (
                  ErpStatusData?.orderPartner?.map(s => {
                    return (
                      <Grid item xs={12} sm={3} lg={3}>
                            <Card>
                              <Grid container column justify='center'>
                                <ListItemAvatar>{getSpareUserColor(s)}</ListItemAvatar>
                              </Grid>
                              <CardContent>
                                <Typography style={{fontWeight: 'bold'}} variant="body1" component="p">
                                  {t('lblOrderNo')}: 
                                </Typography>{s.ORDER_NO}
                                <br/>
                                <Typography style={{fontWeight: 'bold'}} variant="body1" component="p">
                                  {t('lblPartnerCode')}: 
                                </Typography>{s.PARTNERCODE}
                                <br/>
                                <Typography style={{fontWeight: 'bold'}} variant="body1" component="p">
                                  {t('lblPartnerDesc')}: 
                                </Typography>{s.PARTNERDESC}
                                <br/>
                                <Typography style={{fontWeight: 'bold'}} variant="body1" component="p">
                                  {t('lblPartnerType')}: 
                                </Typography>{s.PARTNERTYPE}
                              </CardContent>
                            </Card>
                    </Grid>
                    );
                  })
                )}
              </Grid>
            </DialogContent>
            </Dialog>
            <Dialog
              open={OpenTriageMaterialOrder}
              fullWidth={true}
              maxWidth={'xl'}
              onClose={() => handleCloseTriageMaterialOrder()}
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
            >
            <DialogContent>
              <TriageMaterialOrder
                MaterialIds={notDeliveredMaterials ? notDeliveredMaterials : 0}
                WorkOrderId={workOrderId ? workOrderId : 0}
                getOrderNr={getOrderNr}
                EngineerOrderDescription={
                  `${t('lblEngineerOrderDesc')} ${workOrderId ? workOrderId : 0} ${t('lblWorkOrder')}.`
                }
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => handleCloseTriageMaterialOrder()} color="primary">
                <CloseIcon />
              </Button>
            </DialogActions>
            </Dialog>
            <Dialog
            open={open1}
            onClose={() => setOpen1(false)}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title" color="primary">{t('lblInformation')}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                {Uyari1}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpen1(false)} color="primary">
                {t('lblOK')}
              </Button>
            </DialogActions>
            </Dialog>  
          </div>
        )}
    </div>
  );
}

MaterialStatusManaging.propTypes = {
  className: PropTypes.string
};

export default MaterialStatusManaging;
